module.exports = __webpack_public_path__ + "static/NationalWeb-Bold-0fbf3433e7513c980a8e79f28684fe06.woff2";